import { ClientToSvgPoint } from "./types";

export const clientToSvgPoint: ClientToSvgPoint = ({
  clientX,
  clientY,
  rect,
  viewBox,
}) => ({
  x: viewBox.x + ((clientX - rect.left) / rect.width) * viewBox.w,
  y: viewBox.y + ((clientY - rect.top) / rect.height) * viewBox.h,
});
